// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"b0b02d2ef10324aef54c","147":"67d025771c341b1d9b22","251":"1f091841426d0ab2b03b","352":"1a4cacc28bad1eed0768","544":"da2e9679d2efe0ea37eb"}[chunkId] + ".js";
};